<ng-container *ngIf="(selectedOrganization$ | async) as selectedOrganization">
  <div class="timeline-container">
    <div class="header">
      TIMELINE
    </div>
    <div class="controller">
      <div class="left-group" (document:click)="onDateRangePicker($event, dateRange)" #dateRange>
        <div class="time-range">
          <object type="image/svg+xml" style="width: 16px; height: 16px;"
                  data="assets/images/shared/ic_calendar.svg">Your browser does not support SVGs
          </object>
          <span style="padding-left: 8px; padding-right: 4px;">
          {{fromDate | date:'d MMM yyyy'}} - {{toDate | date:'d MMM yyyy'}}
        </span>
          <object type="image/svg+xml" style="width: 10px; height: 10px; margin-left: 8px;"
                  data="assets/images/shared/ic_caret_down.svg">Your browser does not support SVGs
          </object>
        </div>
        <my-date-range-picker
          style="position: absolute; top: 55px"
          id="daterangepicker"
          name="mydaterange"
          *ngIf="isDatePicker"
          [options]="options"
          [selDateRange]="selectedDateRange"
          (dateRangeChanged)="onDateRangeChanged($event, selectedOrganization.token)">
        </my-date-range-picker>
      </div>
    </div>
    <div class="legend-container">
      <awair-legend [name]="dottedName" [index]="-1"></awair-legend>
      <awair-legend *ngFor="let selectedDevice of selectedDeviceList; let i = index; trackBy: trackByIndex"
                    [name]="selectedDevice.deviceName" [index]="i"></awair-legend>
    </div>

    <div class="graph">
      <!--<div *ngFor="let timelineList of timelineListContainer | keys">
        <awair-timeline-graph
          [fromDate]="fromDate"
          [toDate]="toDate"
          [type]="timelineList?.key"
          [timelineList]="timelineList?.value"
          [dottedTimeline]="safeNav(orgTimelineSet, timelineList.key)">
        </awair-timeline-graph>
      </div>-->
      <awair-timeline-graph id="score-timeline" #scoreTimeline
                            [fromDate]="fromDate"
                            [toDate]="toDate"
                            [type]="AirComponentType.Score"
                            [unit]="AirComponentType.Score | sensorUnit"
                            [selectedDeviceList]="selectedDeviceList"
                            [timelineList]="allTimelineInputContainer?.timelineList.score"
                            [dottedTimeline]="allTimelineInputContainer?.avgTimeline.score"
                            [airNoteListOfDeviceList]="scoreAirNoteListOfDeviceList"
                            [triggerEventListOfDeviceList]="scoreTriggerEventListOfDeviceList">
      </awair-timeline-graph>
      <awair-timeline-graph id="temp-timeline" #tempTimeline
                            [fromDate]="fromDate"
                            [toDate]="toDate"
                            [type]="AirComponentType.Temperature"
                            [unit]="AirComponentType.Temperature | sensorUnit: (selfOrganizationUser$ | async)?.tempUnit"
                            [selectedDeviceList]="selectedDeviceList"
                            [timelineList]="allTimelineInputContainer?.timelineList.temp"
                            [dottedTimeline]="allTimelineInputContainer?.avgTimeline.temp"
                            [airNoteListOfDeviceList]="tempAirNoteListOfDeviceList"
                            [triggerEventListOfDeviceList]="tempTriggerEventListOfDeviceList">
      </awair-timeline-graph>
      <awair-timeline-graph id="humid-timeline" #humidTimeline
                            [fromDate]="fromDate"
                            [toDate]="toDate"
                            [type]="AirComponentType.Humidity"
                            [unit]="AirComponentType.Humidity | sensorUnit"
                            [selectedDeviceList]="selectedDeviceList"
                            [timelineList]="allTimelineInputContainer?.timelineList.humid"
                            [dottedTimeline]="allTimelineInputContainer?.avgTimeline.humid"
                            [airNoteListOfDeviceList]="humidAirNoteListOfDeviceList"
                            [triggerEventListOfDeviceList]="humidTriggerEventListOfDeviceList">
      </awair-timeline-graph>
      <awair-timeline-graph id="co2-timeline" #co2Timeline
                            [fromDate]="fromDate"
                            [toDate]="toDate"
                            [type]="AirComponentType.CO2"
                            [unit]="AirComponentType.CO2 | sensorUnit"
                            [selectedDeviceList]="selectedDeviceList"
                            [timelineList]="allTimelineInputContainer?.timelineList.co2"
                            [dottedTimeline]="allTimelineInputContainer?.avgTimeline.co2"
                            [airNoteListOfDeviceList]="co2AirNoteListOfDeviceList"
                            [triggerEventListOfDeviceList]="co2TriggerEventListOfDeviceList">
      </awair-timeline-graph>
      <awair-timeline-graph id="voc-timeline" #vocTimeline
                            [fromDate]="fromDate"
                            [toDate]="toDate"
                            [type]="AirComponentType.Chemicals"
                            [unit]="AirComponentType.Chemicals | sensorUnit"
                            [selectedDeviceList]="selectedDeviceList"
                            [timelineList]="allTimelineInputContainer?.timelineList.voc"
                            [dottedTimeline]="allTimelineInputContainer?.avgTimeline.voc"
                            [airNoteListOfDeviceList]="vocAirNoteListOfDeviceList"
                            [triggerEventListOfDeviceList]="vocTriggerEventListOfDeviceList">
      </awair-timeline-graph>
      <awair-timeline-graph id="dust-timeline" #dustTimeline
                            *ngIf="hasAwair"
                            [fromDate]="fromDate"
                            [toDate]="toDate"
                            [type]="AirComponentType.Dust"
                            [unit]="AirComponentType.Dust | sensorUnit"
                            [selectedDeviceList]="selectedDeviceList"
                            [timelineList]="allTimelineInputContainer?.timelineList.dust"
                            [dottedTimeline]="allTimelineInputContainer?.avgTimeline.dust"
                            [airNoteListOfDeviceList]="dustAirNoteListOfDeviceList"
                            [triggerEventListOfDeviceList]="dustTriggerEventListOfDeviceList">
      </awair-timeline-graph>
      <awair-timeline-graph id="pm25-timeline" #pm25Timeline
                            *ngIf="hasOmni || hasMint"
                            [fromDate]="fromDate"
                            [toDate]="toDate"
                            [type]="AirComponentType.PM25"
                            [unit]="AirComponentType.PM25 | sensorUnit"
                            [selectedDeviceList]="selectedDeviceList"
                            [timelineList]="allTimelineInputContainer?.timelineList.pm25"
                            [dottedTimeline]="allTimelineInputContainer?.avgTimeline.pm25"
                            [airNoteListOfDeviceList]="pm25AirNoteListOfDeviceList"
                            [triggerEventListOfDeviceList]="pm25TriggerEventListOfDeviceList">
      </awair-timeline-graph>
    </div>
  </div>
</ng-container>
